export default __webpack_public_path__ + "static/media/date.badcfd7b.svg";